<template>
<div>
    <div id="modal-versions" class="modal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Compare Versions</p>
          <button @click="hideModalVersions" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
           <p class="select">
                  <select v-model="version1">
                    <option></option>
                    <option value="oo">OO</option>
                    <option value="oa">OA</option>
                    <option value="ao">AO</option>
                    <option value="br">BR</option>
                  </select>
                </p>
                <p class="select">
                  <select v-model="version2">
                    <option></option>
                    <option value="oo">OO</option>
                    <option value="oa">OA</option>
                    <option value="ao">AO</option>
                    <option value="br">BR</option>
                  </select>
                </p>
                <p class="select">
                  <select v-model="version3">
                    <option></option>
                    <option value="oo">OO</option>
                    <option value="oa">OA</option>
                    <option value="ao">AO</option>
                    <option value="br">BR</option>
                  </select>
                </p>
              <button data-tooltip="Compare" id="compare_button" type="submit" class="button is-success" @click="reload()">
                <span class="icon"><i class="fa fa-arrow-right"></i></span></button>
        </section>
        <!--footer class="modal-card-foot">
          <button @click="hideModalVersions" class="button">OK</button>
        </footer-->
      </div>
    </div>
    <div class="modal" id="modal-help">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Book Generation Help</p>
        </header>
        <section class="modal-card-body">
          <p class="title is-5">Shortcuts</p>
          <ul>
            <li><strong>CMD/CTRL + D</strong> - check ortography</li>
            <li><strong>CMD/CTRL + E</strong> - check ortography for selected line/paragraph</li>
            <li><strong>CMD/CTRL + G</strong> - compare texts</li>
            <li><strong>CMD/CTRL + K</strong> - clear ortography annotations</li>
            <li><strong>CMD/CTRL + J</strong> - clear compare annotations</li>
            <li><strong>CMD/CTRL + S</strong> - save</li>
          </ul>
          <hr>
          <p class="title is-5">Notes</p>
          <p>eBook PDF includes chapters on even pages and widows check... For faster doc generation use draft mode.</p>
        </section>
        <footer class="modal-card-foot">
          <button @click="hideModalHelp" class="button">OK</button>
        </footer>
      </div>
    </div>

    <div class="modal" id="modal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Replace All</p>
          <!--button class="delete" aria-label="close"></button-->
        </header>
        <section class="modal-card-body">
          <div class="field">
            <div class="control">
              <input class="input is-info search-text" type="text" placeholder="Search">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input is-info replace-text" type="text" placeholder="Replace">
            </div>
          </div>
          <p class="help">
          By default matches complete words only (i.e. separated by spaces).<br>
          Use * followed by letters for partial replaces<br>
          Use # for regex match (#\[[0-9]+\])<br>
          To allow partial matching use * at the beginning<br>
           e.g. '*examp'. or '*&lt;p&gt;&lt;br&gt;&lt;/p&gt;'
          </p>
        </section>
        <footer class="modal-card-foot">
          <button @click="replaceAll" class="button is-info">Replace All</button>
          <button @click="hideModal" class="button">Cancel</button>
        </footer>
      </div>
    </div>

    <!-- rich text vue-quill-editor plugin -->
    <div id="editorcontainer" class="columns" :class="(fulltext2 !== '') ? 'split-desktop' : ''">
      <div class="column" :class="(fulltext3 !== '') ? 'is-one-third' : (fulltext2 !== '') ? 'is-half' : 'is-full'">
        <quill-editor ref="myQuillEditor" @change="onEditorChange" @ready="onEditorReady" id="full-text-edit" :class="editorClass" class="full-text full-text-edit-style" v-model="fulltext" :options="editorOptions" />
      </div>
      <div class="column" :class="(fulltext3 !== '') ? 'is-one-third' : (fulltext2 !== '') ? 'is-half' : 'is-full'">
        <quill-editor ref="myQuillEditor2" @change="onEditorChange" @ready="onEditorReady" id="full-text-edit-2" :class="editorClass" class="full-text full-text-edit-style" v-model="fulltext2" :options="editorOptions" />
      </div>
      <div class="column" :class="(fulltext3 !== '') ? 'is-one-third' : (fulltext2 !== '') ? 'is-half' : 'is-full'">
        <quill-editor ref="myQuillEditor3" @change="onEditorChange" @ready="onEditorReady" id="full-text-edit-2" :class="editorClass" class="full-text full-text-edit-style" v-model="fulltext3" :options="editorOptions" />
      </div>
      <div id="loading-overlay" class="loading-overlay">
        <div class="loader center"></div>
        <p class="center">Please wait...</p>
      </div>
    </div>

    <!-- warning notification -->
    <div v-if="notification.message" :class="'notification is-' + notification.type">
      <button class="delete" @click="hideNotifications"></button>{{notification.message}}
    </div>

    <nav class="navbar is-fixed-bottom">
      <div id="navbarBasicExample">

        <div class="navbar-start">
          <div class="navbar-item">
            <div class="buttons">
              <router-link to="/admin/books" class="button is-danger is-light">
                <span class="icon"><i class="fa fa-times"></i></span></router-link>
              <button data-tooltip="Save Text" id="save_button" type="submit" class="button is-success is-light" @click="update(false)">
                <span class="icon"><i class="fa fa-save"></i></span></button>

              <button data-tooltip="Save All Texts" id="save_all_button" type="submit" class="button is-warning is-light is-hidden-mobile" @click="updateAll(false, false)">
                <span class="icon"><i class="fa fa-save"></i></span></button>
              <button data-tooltip="Save All Texts (Delta + HTML)" id="save_all_button" type="submit" class="button is-danger is-light is-hidden-mobile" @click="updateAll(false, true)">
                <span class="icon"><i class="fa fa-save"></i></span></button>
              <button data-tooltip="Search and Replace (CRT/CMD+Y)" id="search_button" type="submit" class="button is-info is-light" @click="showModal">
                <span class="icon"><i class="fa fa-search"></i></span>
              </button>
              <button data-tooltip="Help &amp; Tips" id="help_button" type="submit" class="button is-info is-light is-hidden-mobile" @click="showModalHelp">
                <span class="icon"><i class="fa fa-question-circle"></i></span>
              </button>
              <button data-tooltip="Check 'AO 91' Orthography" id="orth_button" type="submit" class="button is-info is-light" @click="checkOrthographyAgreement()">
                <span class="icon"><i class="fas fa-spell-check"></i></span>
              </button>
              <button v-if="fulltext2 !== ''" data-tooltip="Compare paragraphs" id="orth_button" type="submit" class="button is-info is-light" @click="compareParagraphs()">
                <span class="icon"><i class="fas fa-check"></i></span>
              </button>
              &nbsp;&nbsp;
              <button data-tooltip="Draft PDF (no widow check)" id="export_button" type="submit" class="button" @click="exportPDFDraft">
                <span class="icon"><i class="fa fa-file"></i></span>
              </button>
              <button data-tooltip="Laser Printing File" id="export_button" type="submit" class="button is-hidden-mobile" @click="$refs.asyncComponentRef.exportPDF(version, post, fulltext)">
                <span class="icon"><i class="fa fa-print"></i></span>
              </button>
              <button data-tooltip="eBook Final PDF" id="export_button_ebook" type="submit" class="button is-hidden-mobile" @click="exportPDF">
                <span class="icon"><i class="far fa-file-pdf"></i></span></button>
              <button data-tooltip="ePub XML file" id="export_button_ebook" type="submit" class="button is-hidden-mobile" @click="showNotification('warning', 'Generating xml, please wait…'); $refs.asyncComponentRef.exportEPub(version, post, key, fulltext, true, true)">
                <span class="icon"><i class="far fa-file-alt"></i></span></button>
              <button data-tooltip="ePub file" id="export_button_ebook" type="submit" class="button" @click="showNotification('warning', 'Generating ePub, please wait…'); $refs.asyncComponentRef.exportEPub(version, post, key, fulltext, true)">
                <span class="icon"><i class="fas fa-file-archive"></i></span></button>

              <button data-tooltip="Text Versions" id="help_button" type="submit" class="button is-info is-light" @click="showModalVersions">
                <span class="icon"><i class="fa fa-list-ol"></i></span>
              </button>
              <!-- ORTOGRAPHY OPTIONS -->
              <div class="field has-addons">
                <!--p class="control  is-hidden-mobile">
                  <a data-tooltip="Ortografia Original" class="button" v-bind:class="[version === 'text-oo' ? 'is-info' : 'is-light']" :href="'/admin/book/' + this.key + '/text-oo'">
                    <span>OO</span>
                  </a>
                </p>
                <p class="control">
                  <a data-tooltip="Ortografia Actualizada (1945)" class="button" v-bind:class="[version === 'text' ? 'is-info' : 'is-light']" :href="'/admin/book/' + this.key + ''">
                    <span>OA</span>
                  </a>
                </p>
                <p class="control">
                  <a data-tooltip="Acordo Ortográfico (1990)" class="button" v-bind:class="[version === 'text-ao' ? 'is-info' : 'is-light']" :href="'/admin/book/' + this.key + '/text-ao'">
                    <span>AO</span>
                  </a>
                </p>
                <p class="control">
                  <a data-tooltip="Acordo Ortográfico (1990) - Brasil" class="button" v-bind:class="[version === 'text-br' ? 'is-info' : 'is-light']" :href="'/admin/book/' + this.key + '/text-br'">
                    <span>BR</span>
                  </a>
                </p-->
                <!--p class="control">
                  <a data-tooltip="Comparar Ort. Act. - Ort. Orig." class="button" v-bind:class="[version === 'text-br' ? 'is-info' : 'is-light']" :href="'/admin/book/' + this.key + '/text--text-oo'">
                    <span>OA/OO</span>
                  </a>
                </p>
                <p class="control">
                  <a data-tooltip="Comparar Acord. Ort. - Ort. Act." class="button" v-bind:class="[version === 'text-br' ? 'is-info' : 'is-light']" :href="'/admin/book/' + this.key + '/text-ao--text'">
                    <span>AO/OA</span>
                  </a>
                </p>
                <p class="control">
                  <a data-tooltip="Comparar Ort. Act. - Acord. Ort." class="button" v-bind:class="[version === 'text-br' ? 'is-info' : 'is-light']" :href="'/admin/book/' + this.key + '/text--text-ao'">
                    <span>OA/AO</span>
                  </a>
                </p>
                <p class="control">
                  <a data-tooltip="Comparar Ort. Act. - Br Ort." class="button" v-bind:class="[version === 'text-br' ? 'is-info' : 'is-light']" :href="'/admin/book/' + this.key + '/text--text-br'">
                    <span>OA/BR</span>
                  </a>
                </p-->
              </div>
            </div>
          </div>
        </div>

      </div>
    </nav>

    <AsyncComponent ref="asyncComponentRef" />

</div>
</template>

<script>
import editOptions from './editor-options'
import editOptionsComplete from './editor-options-complete'
// import firebase from 'firebase'
import { textsRef, booksRef, paramsRef } from '@/firebase_config'
import utils from '@/mixins/utils'
import notifier from '@/mixins/notifier'

import Quill from 'quill'
import LanguageTool from 'languagetool-api'

export default {
  name: 'book-text-edit',
  components: {
    AsyncComponent: () => import('./AsyncComponent.vue')
  },
  data () {
    // test custom blot...
    const ParchmentEmbed = Quill.import('blots/block/embed')
    const ATTRS = {
      SERIALIZATION: 'data-serialization',
      VALUE: 'data-value'
    }
    class OrthographyBlot extends ParchmentEmbed {
      static create (value) {
        const node = super.create(value)
        node.setAttribute(ATTRS.SERIALIZATION, value.serialization)
        node.setAttribute(ATTRS.VALUE, value.value)
        node.setAttribute('contenteditable', false)
        node.textContent = value.value
        return node
      }
      static value (node) {
        return {
          value: node.getAttribute(ATTRS.VALUE),
          serialization: node.getAttribute(ATTRS.SERIALIZATION)
        }
      }
    }
    OrthographyBlot.blotName = 'orthography'
    OrthographyBlot.tagName = 'orthog-blot'
    Quill.register(OrthographyBlot)

    // hr block register
    const BlockEmbed = Quill.import('blots/block/embed')
    class DividerBlot extends BlockEmbed {
      static create (url) {
        let node = super.create()
        node.innerHTML = '---'
        return node
      }
    }
    DividerBlot.blotName = 'hr'
    DividerBlot.className = 'hr'
    DividerBlot.tagName = 'hr'
    Quill.register(DividerBlot)

    class DividerAdvanceBlot extends BlockEmbed {}
    DividerAdvanceBlot.blotName = 'hr-advance'
    DividerAdvanceBlot.className = 'hr-advance'
    DividerAdvanceBlot.tagName = 'hr'
    Quill.register(DividerAdvanceBlot)

    // add H3 toolbar missing icon
    var iconH3 = `
      <svg width="17px" height="12px" viewBox="0 0 17 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="h3" fill="lightgrey">
                  <path d="M1.992,12.728 C1.81066576,12.9093342 1.58966797,13 1.329,13 C1.06833203,13 0.84733424,12.9093342 0.666,12.728 C0.48466576,12.5466658 0.394,12.325668 0.394,12.065 L0.394,1.525 C0.394,1.26433203 0.48466576,1.04333424 0.666,0.862 C0.84733424,0.68066576 1.06833203,0.59 1.329,0.59 C1.58966797,0.59 1.81066576,0.68066576 1.992,0.862 C2.17333424,1.04333424 2.264,1.26433203 2.264,1.525 L2.264,5.503 C2.264,5.60500051 2.31499949,5.656 2.417,5.656 L7.381,5.656 C7.48300051,5.656 7.534,5.60500051 7.534,5.503 L7.534,1.525 C7.534,1.26433203 7.62466576,1.04333424 7.806,0.862 C7.98733424,0.68066576 8.20833203,0.59 8.469,0.59 C8.72966797,0.59 8.95066576,0.68066576 9.132,0.862 C9.31333424,1.04333424 9.404,1.26433203 9.404,1.525 L9.404,12.065 C9.404,12.325668 9.31333424,12.5466658 9.132,12.728 C8.95066576,12.9093342 8.72966797,13 8.469,13 C8.20833203,13 7.98733424,12.9093342 7.806,12.728 C7.62466576,12.5466658 7.534,12.325668 7.534,12.065 L7.534,7.271 C7.534,7.16899949 7.48300051,7.118 7.381,7.118 L2.417,7.118 C2.31499949,7.118 2.264,7.16899949 2.264,7.271 L2.264,12.065 C2.264,12.325668 2.17333424,12.5466658 1.992,12.728 Z M11.32,7.07 C11.1666659,7.07 11.0333339,7.0133339 10.92,6.9 C10.8066661,6.7866661 10.75,6.6533341 10.75,6.5 L10.75,6.27 C10.75,6.1166659 10.8066661,5.9833339 10.92,5.87 C11.0333339,5.7566661 11.1666659,5.7 11.32,5.7 L15.05,5.7 C15.2033341,5.7 15.3366661,5.7566661 15.45,5.87 C15.5633339,5.9833339 15.62,6.1166659 15.62,6.27 L15.62,6.5 C15.62,6.8800019 15.4733348,7.1899988 15.18,7.43 L13.67,8.68 L13.67,8.69 C13.67,8.6966667 13.6733333,8.7 13.68,8.7 L13.8,8.7 C14.3800029,8.7 14.8449983,8.8799982 15.195,9.24 C15.5450018,9.6000018 15.72,10.0866636 15.72,10.7 C15.72,11.4733372 15.4833357,12.0666646 15.01,12.48 C14.5366643,12.8933354 13.8566711,13.1 12.97,13.1 C12.436664,13.1 11.8966694,13.0366673 11.35,12.91 C11.1899992,12.8699998 11.0583339,12.7816674 10.955,12.645 C10.8516662,12.5083327 10.8,12.3533342 10.8,12.18 L10.8,11.84 C10.8,11.706666 10.8549995,11.6016671 10.965,11.525 C11.0750006,11.448333 11.196666,11.4299998 11.33,11.47 C11.9033362,11.6566676 12.4033312,11.75 12.83,11.75 C13.2166686,11.75 13.5166656,11.6600009 13.73,11.48 C13.9433344,11.2999991 14.05,11.0500016 14.05,10.73 C14.05,10.4033317 13.9266679,10.173334 13.68,10.04 C13.4333321,9.906666 12.9733367,9.8366667 12.3,9.83 C12.1466659,9.83 12.0133339,9.77500055 11.9,9.665 C11.7866661,9.55499945 11.73,9.4233341 11.73,9.27 L11.73,9.25 C11.73,8.8766648 11.8733319,8.5666679 12.16,8.32 L13.58,7.09 L13.58,7.08 C13.58,7.0733333 13.5766667,7.07 13.57,7.07 L11.32,7.07 Z" id="Shape" fill-rule="nonzero"></path>
              </g>
          </g>
      </svg>`
    var icons = Quill.import('ui/icons')
    icons.header[3] = iconH3
    var self = this
    this.key = this.$route.params.key
    this.version = this.$route.params.version
    if (!this.version) {
      this.version = 'text' // supported text versions are text text-oo text-oa text-ao
    }
    booksRef.child(this.key).once('value').then(function (textSnapshot) {
      self.post = textSnapshot.val()
    })
    // display different interface on mobile to optimize for device space
    // editorOptions.theme = 'snow'
    var editorOptions = self.isMobile() ? editOptions : editOptionsComplete
    return {
      fulltext: '',
      fulltext2: '',
      fulltext3: '',
      editorClass: self.isMobile() ? 'mobile' : 'desktop',
      editorOptions,
      version1: '',
      version2: '',
      version3: '',
      versions: []
    }
  },
  firebase: {
    texts: textsRef,
    books: booksRef
  },
  props: ['update-post'],
  mixins: [ utils, textsRef, notifier ],
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    reload () {
      var base = '/admin/book/' + this.$route.params.key // this.$route.path.replaceAll('/text-oo', '').replaceAll('/text-ao', '').replaceAll('/text-oa', '').replaceAll('/text-br', '')
      base = base + '/'
      if (this.version1) {
        base = base + 'text-' + this.version1 + '--'
      }
      if (this.version2) {
        base = base + 'text-' + this.version2 + '--'
      }
      if (this.version3) {
        base = base + 'text-' + this.version3 + '--'
      }
      base = base.replace(/--$/g, '').replace(/-oa/g, '')
      window.location.href = base
    },
    // verifica apenas ortografia do acordo ortografico e erros basicos
    checkOrthographyAgreement () {
      checkOrthographySelection(this.version, true, this)
    },
    checkOrthography (all) {
      if (all) {
        checkOrthographyAll(this.version)
      } else {
        checkOrthographySelection(this.version, false, this)
      }
    },
    compareParagraphs () {
      // clearCompareAnnotations()
      new Promise((resolve, reject) => {
        clearCompareAnnotations()
        // move cursor 1 char
        var sel = window.getSelection()
        var textNode = sel.focusNode
        var newOffset = sel.focusOffset + 1
        sel.collapse(textNode, Math.min(textNode.length, newOffset))
        // next!
        resolve()
      })
        .then(() => {
          compareSelection(this.fulltext, this.fulltext2)
        })
    },
    exportPDFDraft () {
      var self = this
      this.showNotification('warning', 'Generating draft PDF, please wait…')
      setTimeout(function () {
        self.$refs.asyncComponentRef.exportPDF(self.version, self.post, self.fulltext, true, true)
      }, 500)
    },
    exportPDF () {
      var self = this
      this.showNotification('info', 'Generating PDF, please wait…')
      setTimeout(function () {
        self.$refs.asyncComponentRef.exportPDF(self.version, self.post, self.fulltext, true)
      }, 500)
    },
    updateAll (publish, saveHtml) {
      this.update(publish)
      for (var i = 0; i < this.versions.length; i++) {
        this.update(publish, this.versions[i], saveHtml)
      }
    },
    update (publish, ver, saveHtml) {
      if (publish) {
        this.post.state = 'published'
      }
      if (!ver) {
        ver = this.version
      }

      var text = ''
      var delta = ''

      if (this.versions.indexOf(ver) === 0) {
        delta = this.$refs.myQuillEditor.quill.getContents()
        text = this.fulltext.replace(/<u style="background-color:((?!>).)*>/g, '') // replace <u> elements: ((?!>).)* means anything except >
      } else if (this.versions.indexOf(ver) === 1) {
        delta = this.$refs.myQuillEditor2.quill.getContents()
        text = this.fulltext2.replace(/<u style="background-color:((?!>).)*>/g, '') // replace <u> elements: ((?!>).)* means anything except >
      } else if (this.versions.indexOf(ver) === 2) {
        delta = this.$refs.myQuillEditor3.quill.getContents()
        text = this.fulltext3.replace(/<u style="background-color:((?!>).)*>/g, '') // replace <u> elements: ((?!>).)* means anything except >
      }

      // clean html
      if (text.indexOf('<u') >= 0) {
        this.showNotification('error', 'Text contains <u>, can\'t be saved…')
        return
      }
      // console.log(this.fulltext)
      // save to firebase
      this.$firebaseRefs.texts.child(this.key).child('delta').child(ver).set(delta).then(() => {
        this.showNotification('success', 'Book delta updated successfully')
        if (saveHtml) {
          this.$firebaseRefs.texts.child(this.key).child(ver).set(text).then(() => {
            this.showNotification('success', 'Book text updated successfully')
          })
        }
      }).catch(() => {
        this.showNotification('danger', 'Couldn\'t save the document')
      })
    },
    showModalHelp () {
      document.getElementById('modal-help').classList.add('is-active')
    },
    showModalVersions () {
      document.getElementById('modal-versions').classList.add('is-active')
    },
    hideModalVersions () {
      document.getElementById('modal-versions').classList.remove('is-active')
    },
    showModal () {
      document.getElementById('modal').classList.add('is-active')
      // show selected text in input field
      var selection = window.getSelection()
      if (selection.rangeCount > 0) {
        document.getElementsByClassName('search-text')[0].value = selection
        document.getElementsByClassName('replace-text')[0].value = selection
      }
    },
    hideModalHelp () {
      document.getElementById('modal-help').classList.remove('is-active')
    },
    hideModal () {
      document.getElementById('modal').classList.remove('is-active')
    },
    escapeRegExp (string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
    },
    replaceAll () {
      var search = document.getElementsByClassName('search-text')[0].value
      var replace = document.getElementsByClassName('replace-text')[0].value
      if (!search.startsWith('.') && !search.startsWith('*') && !search.startsWith('#')) {
        paramsRef.child('orthography').child(search).set(replace)
      }
      var fullText = document.getElementById('full-text-edit')
      if (fullText) {
        document.getElementById('loading-overlay').style.display = 'inline-block'
        var currentScroll = document.documentElement.scrollTop
        var el = fullText.querySelector('.ql-editor')
        var se
        if (search.startsWith('*')) {
          se = new RegExp(this.escapeRegExp(search.replace('*', '')), 'g')
        } else if (search.startsWith('#')) {
          se = new RegExp(search.replace('#', ''), 'g')
        } else {
          se = new RegExp('\\b' + this.escapeRegExp(search) + '\\b', 'g')
        }
        var match = el.innerHTML.match(se)
        console.log(el.innerHTML)
        var count = (match != null) ? match.length : 0

        if (replace.length > 0) {
          el.innerHTML = el.innerHTML.replace(se, '<span style="background-color: rgb(255, 255, 0);">' + replace + '</span>')
        } else {
          el.innerHTML = el.innerHTML.replace(se, '')
        }

        document.documentElement.scrollTop = currentScroll
        document.getElementById('loading-overlay').style.display = 'none'
        this.showNotification('success', 'Replaced ' + count + ' occurences')
        console.log('replaced text')
      }
      this.hideModal()
    },
    onEditorReady () {
      console.log('editor ready')
      // console.log(this.$refs.myQuillEditor.quill.scrollingContainer)
      /* window.addEventListener('scroll', (e) => {
        console.log('scroll ' + e.target.activeElement)
        console.log(e)
      }) */
    },
    onEditorChange () {
      console.log('editor change')
      // { quill, html, text }
      // console.log('editor change!', quill, html, text)
      // this.content = html
      // restore last scroll position
      if (!this.reloaded && getCookie('ScrollTop')) {
        console.log('scroll ' + getCookie('ScrollTop'))
        this.reloaded = true
        setTimeout(function () {
          document.documentElement.scrollTop = getCookie('ScrollTop') // document.body.scrollTop
        }, 100)
      }
      // hide loading overlay
      this.hideLoading()
    },
    showLoading () {
      document.getElementById('loading-overlay').style.display = 'inline-block'
    },
    hideLoading () {
      document.getElementById('loading-overlay').style.display = 'none'
    },
    findDiff (oldContent, newContent) {
      console.log('find diff')
      var diff = oldContent.diff(newContent)
      // console.log('old', oldContent)
      // console.log('new', newContent)
      for (var i = 0; i < diff.ops.length; i++) {
        var op = diff.ops[i]
        // if the change was an insertion
        if (op.hasOwnProperty('insert')) {
          // color it green
          op.attributes = {
            background: '#cce8cc',
            color: '#003700'
          }
        }
        // if the change was a deletion
        if (op.hasOwnProperty('delete')) {
          // keep the text
          op.retain = op.delete
          delete op.delete
          // but color it red and struckthrough
          op.attributes = {
            background: '#e8cccc',
            color: '#370000',
            strike: true
          }
        }
      }
      // console.log('diff', diff);
      var adjusted = oldContent.compose(diff)
      // console.log('adjusted', adjusted)
      // profit!
      this.$refs.myQuillEditor3.quill.setContents(adjusted)
      console.log('adjusted')
    },
    loadFullText (ver, alt) {
      var self = this
      // Code that will run only after the
      // entire view has been rendered
      setTimeout(function () {
        // load book text
        console.log('Dowloading full text.')
        textsRef.child(self.key).child('delta').child(ver).once('value').then(function (deltaSnapshot) {
          if (deltaSnapshot.val()) {
            console.log('Dowloaded delta.')
            console.log(self.$refs)
            if (alt === '1') {
              self.$refs.myQuillEditor2.quill.setContents(deltaSnapshot.val())
              // self.findDiff(self.$refs.myQuillEditor.quill.getContents(), self.$refs.myQuillEditor2.quill.getContents())
            } else if (alt === '2') {
              self.$refs.myQuillEditor3.quill.setContents(deltaSnapshot.val())
            } else {
              self.$refs.myQuillEditor.quill.setContents(deltaSnapshot.val())
            }
          } else {
            // load full text
            textsRef.child(self.key).child(ver).once('value').then(function (textSnapshot) {
              if (textSnapshot.val()) {
                console.log('Dowloaded full text.')
                // var tmp = self.fixDiacritics(textSnapshot.val()).split(/<h2 class="ql-align-center">/g)[2]
                if (alt === '1') {
                  self.fulltext2 = self.fixDiacritics(textSnapshot.val())
                } else if (alt === '2') {
                  self.fulltext3 = self.fixDiacritics(textSnapshot.val())
                } else {
                  self.fulltext = self.fixDiacritics(textSnapshot.val())
                }
              } else {
                console.log('Empty text.')
                self.fulltext = ' - '
              }
            })
          }
        })
      }, 500)
    }
  },
  updated: function () {
    // show alow images in full size
    var elements = document.getElementsByTagName('p')
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].innerHTML.indexOf('<img') === 0) {
        elements[i].firstElementChild.classList.add('full-img')
      }
      // elements[i].innerHTML = elements[i].innerHTML.replace(/\\b([a-z])([a-z]+)?\\b/gim, "<span class='first-letter'>$1</span>$2")
    }
  },
  beforeDestroy () {
    console.log('Destroyed')
    document.getElementById('sidebar').style.display = 'inline-block'
    document.getElementById('navbar').style.display = 'flex'
    document.getElementsByClassName('admin-wrapper')[0].style.width = 'calc(100% - 115px)'
    document.getElementsByClassName('admin-wrapper')[0].style.left = '115px'
    document.getElementsByClassName('admin-wrapper')[0].style.top = '52px'
  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor.quill
    },
    editor2 () {
      return this.$refs.myQuillEditor2.quill
    }
  },
  created: function () {
    var self = this
    document.addEventListener('keydown', function (event) {
      if (event.code === 'KeyY' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault()
        self.showModal()
      } else if (event.code === 'KeyE' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault()
        self.checkOrthography()
      } else if (event.code === 'KeyD' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault()
        self.checkOrthography(true)
      } else if (event.code === 'KeyK' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault()
        clearOrthographyAnnotations()
      } else if (event.code === 'KeyJ' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault()
        clearCompareAnnotations()
      } else if (event.code === 'KeyG' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault()
        compareParagraphs(self.fulltext, self.fulltext2)
      }
    })
  },
  mounted: function () {
    this.reloaded = false
    console.log('mounted')

    if (this.$route.params.version) {
      var params = this.$route.params.version.split('--')
      if (params[0]) {
        this.versions.push(params[0])
        this.version1 = params[0].replace('text-', '').replace('text', 'oa')
      }
      if (params[1]) {
        this.versions.push(params[1])
        this.version2 = params[1].replace('text-', '').replace('text', 'oa')
      }
      if (params[2]) {
        this.versions.push(params[2])
        this.version3 = params[2].replace('text-', '').replace('text', 'oa')
      }
    } else {
      // default
      this.versions.push(this.version)
      this.version1 = this.version.replace('text-', '').replace('text', 'oa')
    }

    document.getElementById('sidebar').style.display = 'none'
    document.getElementById('navbar').style.display = 'none'
    document.getElementsByClassName('admin-wrapper')[0].style.width = '100%'
    document.getElementsByClassName('admin-wrapper')[0].style.left = '0'
    document.getElementsByClassName('admin-wrapper')[0].style.top = '0'

    var q = document.getElementsByClassName('ql-toolbar')
    q[0].addEventListener('mousedown', function (event) {
      event.preventDefault()
      event.stopPropagation()
    })

    // clear pasted text
    var fullText = document.getElementById('full-text-edit')
    if (fullText) {
      fullText.addEventListener('paste', function (e) {
        // document.documentElement.scrollTop = getCookie('ScrollTop') // document.body.scrollTop
        // var currentScroll = document.documentElement.scrollTop
        // document.documentElement.scrollTop = currentScroll
        e.preventDefault()
        e.stopPropagation()
        console.log('paste')
        var plain = (e.clipboardData) ? e.clipboardData.getData('text/html') : window.clipboardData.getData('Text')
        // console.log('>' + plain)
        // plain = plain.replace(/<(?!br|p|\/p|h1|h2|\/h1|\/h2|b|\/b|em|\/em\s*\/?)[^>]+>/g, '')
        plain = plain.replace(/<(?!br|p|\/p|h1|h2|\/h1|\/h2|\s*\/?)[^>]+>/g, '')
        plain = plain.replace(/ style="[^"]*"/g, '')
        plain = plain.replace(/&nbsp;/g, ' ')
        // console.log('>>' + plain) // .replace(/<\/?span[^>]*>/g, '')
        document.execCommand('insertHTML', false, plain)
      })
    }

    if (this.version.indexOf('--') >= 0) {
      var tmp = this.version.split('--')
      this.version = tmp[0]
      this.loadFullText(this.version) // default text
      this.loadFullText(tmp[1], '1') // new ao text
      if (tmp[2]) {
        this.loadFullText(tmp[2], '2') // new ao text
      }
    } else {
      this.loadFullText(this.version)
    }

    console.log('mounted finished')
  }
}
function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

function compareParagraphs () {
  var self = this
  new Promise((resolve, reject) => {
    clearCompareAnnotations()
    resolve()
  })
    .then(() => {
      console.log('Do this')
      compareSelection(self.fulltext, self.fulltext2)
    })
}

// get saved cookie
function getCookie (cname) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

// TODO: in progress...
function compareSelection (fulltext, fulltext2) {
  var range = window.getSelection().getRangeAt(0)

  // select only node contents when selection done with 3 clicks
  if (range.startOffset === range.endOffset) {
    if (range.startContainer.parentElement.tagName === 'P' ||
      range.startContainer.parentElement.tagName === 'EM') {
      range.selectNodeContents(range.startContainer.parentElement)
      console.info('ADJUSTED SELECTION')
    }
  }
  const index = Array.prototype.indexOf.call(range.startContainer.parentElement.childNodes, range.startContainer)
  console.info(index)
  var altHtml = document.createElement('div')
  altHtml.innerHTML = fulltext2
  clearAnnotations(altHtml, true)
  let altText = altHtml.childNodes[index].innerHTML
  altText = altText.replace(/…/g, '...')
  console.log(altText)

  var selectionContents = range.cloneContents()
  var el = document.createElement('span')
  el.appendChild(selectionContents)
  clearAnnotations(el, true)
  console.log(el.innerHTML)
  clearCompareAnnotations(el)
  var text = el.innerHTML.replace(/&amp;/g, '%') // hack... & sign not being handled by server or lib...
  console.log(text)
  if (altText !== text) {
    console.log('MISMATCH')
    var textTmp = ''
    const altTextTmp = altText.split(' ')
    let position = 0
    text.split(' ').forEach(function (val, i) {
      if (val !== altTextTmp[i]) {
        console.log('MISMATCH word ' + position)
        textTmp += '<span style="background-color: orange;">' + val + '</span> '
        // textTmp += '<span class="highlight">' + val + '</span> '
        // var highlightRange = createRangeByOffset(el, position, position + val.length)
        // highlightRange.surroundContents(highlight('message'))
      } else {
        textTmp += val + ' '
      }
      position += val.length + 1
    })
    console.log(textTmp)
    el.innerHTML = textTmp
    range.deleteContents()
    range.insertNode(el)
  }
}

// update to 1990 ortography
function updateOrthography () { // eslint-disable-line no-unused-vars
  console.log('Updating ortography... please wait.')
  var currentScroll = document.documentElement.scrollTop
  var fullText = document.getElementById('full-text-edit')
  // var inner = fullText.querySelector('.ql-editor').innerHTML
  var el = fullText.querySelector('.ql-editor')
  // orthography ao1990
  paramsRef.child('orthography').once('value').then(function (textSnapshot) {
    var replaceList = textSnapshot.val()
    console.log(capitalizeFirstLetter('a'))
    // add special cases (capital letter, plural, etc)
    // for (var word in replaceList) {
    // replaceList[capitalizeFirstLetter(word)] = capitalizeFirstLetter(replaceList[word])
    // replaceList[capitalizeFirstLetter(word) + 's'] = capitalizeFirstLetter(replaceList[word]) + 's'
    // replaceList[word + 's'] = replaceList[word] + 's'
    // }

    for (var key in replaceList) {
      console.log(key + ' ' + replaceList[key])
      if (key.startsWith('*')) {
        var se3 = new RegExp(key.replace('*', ''), 'g')
        el.innerHTML = el.innerHTML.replace(se3, '<span style="background-color: rgb(255, 255, 0);">' + replaceList[key] + '</span>')
      } else {
        var se0 = new RegExp('\\b' + key + '\\b', 'g')
        el.innerHTML = el.innerHTML.replace(se0, '<span style="background-color: rgb(255, 255, 0);">' + replaceList[key] + '</span>')
      }
    }

    // document.execCommand('selectAll', false, null)
    // document.execCommand('delete', false, null)
    // document.execCommand('insertHTML', false, inner)
    document.documentElement.scrollTop = currentScroll
  })
}

/* eslint-disable no-unused-vars */
function checkOrthographyAll (version, agreement) {
  clearOrthographyAnnotations()
  console.log('checkOrthographyAll')
  var fullText = document.getElementById('full-text-edit')
  var el = fullText.querySelector('.ql-editor')
  var children = el.children
  for (var i = 0, max = children.length; i < max; i++) {
    var child = children[i]
    var range = document.createRange()
    // range.setStart(child, 0)
    // range.setEnd(child, 0)
    range.selectNodeContents(child)
    // var newNode = document.createElement('b')
    // range.surroundContents(newNode)
    // console.log(range)
    checkRangeOrthography(range, version, agreement)
  }
}

function checkOrthographySelection (version, agreement, self) {
  var range = window.getSelection().getRangeAt(0)
  console.log(range)
  // select only node contents when selection done with 3 clicks
  if (range.startOffset === range.endOffset) {
    console.log(range.startContainer.parentElement.tagName)
    if (range.startContainer.parentElement.tagName === 'P' ||
      range.startContainer.parentElement.tagName === 'EM') {
      // console.log(range.startContainer.parentElement)
      range.selectNodeContents(range.startContainer.parentElement)
      console.info('ADJUSTED SELECTION')
      // self.showNotification('warning', 'ADJUSTED SELECTION…')
    }
  }
  // clearOrthographyAnnotations()
  checkRangeOrthography(range, version, agreement)
}

function clearCompareAnnotations (el, all) {
  if (all) {
    var fullText = document.getElementById('full-text-edit')
    el = fullText.querySelector('.ql-editor')
    el.innerHTML = el.innerHTML
      .replace(/<span style="background-color: orange;">([^<]*)<\/span>/g, '$1')
      .replace(/style="background-color: orange;"/g, '')
  } else if (el) {
    el.innerHTML = el.innerHTML
      .replace(/<span style="background-color: orange;">([^<]*)<\/span>/g, '$1')
      .replace(/style="background-color: orange;"/g, '')
  } else {
    var range = window.getSelection().getRangeAt(0)
    // select only node contents when selection done with 3 clicks
    if (range.startOffset === range.endOffset) {
      if (range.startContainer.parentElement.tagName === 'P' ||
        range.startContainer.parentElement.tagName === 'EM') {
        range.selectNodeContents(range.startContainer.parentElement)
        console.info('ADJUSTED SELECTION')
      }
    }
    var selectionContents = range.cloneContents()
    el = document.createElement('span')
    el.appendChild(selectionContents)
    el.innerHTML = el.innerHTML
      .replace(/<span style="background-color: orange;">([^<]*)<\/span>/g, '$1')
      .replace(/style="background-color: orange;"/g, '')
    range.deleteContents()
    range.insertNode(el)
  }
}

function clearAnnotations (el, all) {
  // remove dropdowns...
  const removeElements = (elms) => elms.forEach(el => el.remove())
  removeElements(document.querySelectorAll('.dropdown-content'))
  const removeAttributes = (elms) => elms.forEach(el => {
    el.removeAttribute('class')
    el.removeAttribute('href')
  })
  removeAttributes(document.querySelectorAll('.dropbtn'))
  el.innerHTML = el.innerHTML
    .replace(/<orthog-blot class="dropdown">/g, '')
    .replace(/<\/orthog-blot>/g, '')
    .replace(/<a>/g, '')
    .replace(/<\/a>/g, '')
    .replace(/<u class="(highlight|corrected)" ((?!>).)*>/g, '')
    .replace(/<\/u>/g, '')
  if (all) {
    el.innerHTML = el.innerHTML
      .replace(/<span style="background-color: rgb\(255, 255, 0\);">/g, '')
      .replace(/<\/span>/g, '')
      // .replace(/<em style="background-color: rgb\(255, 255, 0\);">([^<]*)<\/em>/g, '$1')
  }
}

function clearAllAnnotations () {
  var fullText = document.getElementById('full-text-edit')
  var el = fullText.querySelector('.ql-editor')
  clearAnnotations(el, true)
}

function clearOrthographyAnnotations () {
  var fullText = document.getElementById('full-text-edit')
  var el = fullText.querySelector('.ql-editor')
  clearAnnotations(el)
}

/**
 * Language Check Methods
 * Uses languagetool local server
 * java -cp languagetool-server.jar org.languagetool.server.HTTPServer --port 8081 --allow-origin "*"
 */

function determineRelativeOffsets (node, varObj, start, end) { // eslint-disable-line no-unused-vars
  for (var i = 0; i < node.childNodes.length; i++) {
    var child = node.childNodes[i]
    if (child.length) {
      if (!varObj.startContainer && start < (varObj.count + child.length)) {
        varObj.startContainer = child
        varObj.startOffset = start - varObj.count
      }
      if (!varObj.endContainer && end <= (varObj.count + child.length)) {
        varObj.endContainer = child
        varObj.endOffset = end - varObj.count
      }
      varObj.count += child.length
      // console.log(child.textContent)
      // console.log(varObj.count)
    } else {
      var tmp = document.createElement('div')
      tmp.appendChild(child.cloneNode(true))
      var tmpSplit = tmp.innerHTML.split(child.innerHTML)
      varObj.count += tmpSplit[0].length // opening tag length
      // console.log(tmpSplit[0])
      // console.log(varObj.count)
      determineRelativeOffsets(child, varObj, start, end)
      if (tmpSplit.length > 1) {
        varObj.count += tmpSplit[1].length // closing tag length
        // console.log(tmpSplit[1])
        // console.log(varObj.count)
      }
    }
  }
}

function createRangeByOffset (element, start, end) { // eslint-disable-line no-unused-vars
  // console.log('start ' + start)
  // console.log('end ' + end)
  var range = document.createRange()
  // var tmpEl = document.createElement('div')
  // tmpEl.appendChild(element.cloneNode(true))
  // console.log(tmpEl.innerHTML)
  let varObj = { count: 0 }
  determineRelativeOffsets(element, varObj, start, end)
  // console.log(varObj)
  if (varObj.startContainer !== varObj.endContainer) {
    // TODO: this is a know limitation;
    // currently we can't handle <em>teste <b>bold</b> dentro em</em>
    // when the error starts in teste and ends in em...
    // see https://developer.mozilla.org/en-US/docs/Web/API/Range/startOffset
    console.error('COULD NOT HIGHLIGHT TEXT')
    console.error('Adjusting range...')
    varObj.startContainer = varObj.endContainer.parentNode
    varObj.startOffset = 0
    varObj.endContainer = varObj.startContainer
    varObj.endOffset = 0
  }
  range.setStart(varObj.startContainer, varObj.startOffset)
  range.setEnd(varObj.endContainer, varObj.endOffset)
  // console.log(range)
  return range
}

// to surround the range with a highlighting span
function highlight (message, replacements, warning) { // eslint-disable-line no-unused-vars
  var el = document.createElement('u')
  el.setAttribute('class', 'highlight')
  el.title = message + ' '
  if (replacements) {
    replacements.map(item => {
      el.title = el.title + item.value + ', '
    })
  }
  // el.setAttribute('data-tooltip', el.title)
  if (warning === 'PT_BR_SIMPLE_REPLACE') {
    el.style.backgroundColor = 'var(--warning-bg-color)'
  } else if (warning === 'PT_AGREEMENT_REPLACE') {
    el.style.backgroundColor = 'var(--warning-bg-color)'
  } else {
    el.style.backgroundColor = 'var(--error-bg-color)'
  }
  // show dropdown with suggestions...
  el.addEventListener('click', function (event) {
    if (replacements && replacements.length > 0 && !el.getAttribute('has-data')) {
      el.setAttribute('has-data', 'true')
      var myParent = event.target
      var div = document.createElement('div')
      div.setAttribute('class', 'dropdown-content')
      var aDown = document.createElement('a')
      aDown.setAttribute('class', 'dropbtn')
      aDown.setAttribute('href', 'javascript:void(0)')
      aDown.text = el.textContent
      for (var i = 0; i < replacements.length; i++) {
        var a = document.createElement('a')
        a.text = replacements[i].value
        a.addEventListener('click', function (e) {
          e.stopPropagation()
          aDown.text = e.target.text
        })
        div.appendChild(a)
      }
      var option = document.createElement('orthog-blot')
      option.setAttribute('class', 'dropdown')
      event.target.innerHTML = ''
      option.appendChild(aDown)
      option.appendChild(div)
      event.target.appendChild(option)
    }
  })
  return el
}

/**
 * Convert HMTL to array with text and annotations for LanguageTool check
 */
function htmlToDataArray (html) {
  var results = []
  html.replace(/([^<>]*?)(<\/?[-:\w]+(?:>|\s[^<>]*?>)|$)/g, function (a, b, c) {
    if (b) results.push({'text': b})
    if (c) results.push({'markup': c})
  })
  return {'annotation': results}
}

/**
 * Test API at https://languagetool.org/http-api/swagger-ui/#!/default/post_check
 * Rules from
 * https://github.com/languagetool-org/languagetool/blob/12b7efe4b2a89d8ebd1bc42c5f27940ed13f1d61/languagetool-language-modules/pt/src/test/java/org/languagetool/rules/pt/PortugueseTest.java
 */
function languageToolParams (version, agreement, data) {
  // set server: local, default remote
  // LanguageTool.setServerUrl('http://localhost:8081/v2/check')

  // "POSSESSIVE_WITHOUT_ARTICLE", "SPACE_AFTER_PUNCTUATION", "GENERAL_GENDER_AGREEMENT_ERRORS",
  // "AFIM_DE", "PORTUGUESE_WORD_REPEAT_RULE", "PT_AGREEMENT_REPLACE", "TAL_VEZ", "GENERAL_NUMBER_AGREEMENT_ERRORS",
  // "GENERAL_VERB_AGREEMENT_ERRORS", "UPPERCASE_SENTENCE_START", "HUNSPELL_RULE",
  // "UNPAIRED_BRACKETS", "DOUBLE_PUNCTUATION", "PHRASE_REPETITION", "REPEATED_WORDS", "ARTICLES_PRECEDING_LOCATIONS",
  // "PARONYM_ANALISE_363", "DOUBLE_PUNCTUATION", "POSSESSIVE_WITHOUT_ARTICLE", "EQUIPES", "T-V_DISTINCTION", "DATE_WEEKDAY"

  // PT_PT_SIMPLE_REPLACE PT_BR_SIMPLE_REPLACE PT_AGREEMENT_REPLACE
  var enabledRules = 'PT_AGREEMENT_REPLACE'
  var enabledOnly = false // If true, only the rules and categories whose IDs are specified with enabledRules or enabledCategories are enabled.
  // var disabledRules = ''
  var lang = 'pt-AO' // AO=Angola (ainda usa acordo 1945);  pt-PT pt-AO pt-BR
  if (version === 'text-ao') {
    lang = 'pt-PT'
    if (agreement) {
      enabledOnly = true
      enabledRules = 'PT_PT_SIMPLE_REPLACE,HUNSPELL_RULE,PT_AGREEMENT_REPLACE'
    }
  } else if (version === 'text-br') {
    lang = 'pt-BR'
    if (agreement) {
      enabledOnly = true
      enabledRules = 'PT_BR_SIMPLE_REPLACE,HUNSPELL_RULE,PT_AGREEMENT_REPLACE'
    }
  }
  return { language: lang, data: data, enabledOnly: enabledOnly, enabledRules: enabledRules }
}

function checkRangeOrthography (range, version, agreement) {
  var selectionContents = range.cloneContents()
  var el = document.createElement('span')
  el.appendChild(selectionContents)
  clearAnnotations(el)
  // console.log(range)
  // console.log(el.innerHTML)
  var text = htmlToDataArray(el.innerHTML.replace(/&amp;/g, '%')) // hack... & sign not being handled by server or lib...
  // console.log(text)
  var params = languageToolParams(version, agreement, JSON.stringify(text))
  LanguageTool.check(params, function (err, res) {
    if (err) {
      console.log(err)
    } else {
      // console.log(res)
      console.log('Got ' + res.matches.length + ' corrections…')
      for (var i = res.matches.length - 1; i >= 0; i--) {
        var match = res.matches[i]
        console.log(match)
        console.log(match.rule.id)
        var highlightRange = createRangeByOffset(el, match.offset, match.offset + match.length)
        highlightRange.surroundContents(highlight(match.message, match.replacements, match.rule.id))
      }
      range.deleteContents()
      // avoid duplicating contents... if method called twice or more time...
      if (range.startContainer.innerHTML && range.startContainer.innerHTML.indexOf('highlight') >= 0) {
        return
      }
      range.insertNode(el)
    }
  })
}

function checkRangeOrthographyOLDVERSION (range) { // eslint-disable-line no-unused-vars
  var selectionContents = range.cloneContents()
  var el = document.createElement('span')
  if (selectionContents.textContent.length === 0) {
    return
  }
  el.appendChild(selectionContents)
  // console.log('#' + selection.rangeCount)
  // console.log(selectionContents)
  // el.setAttribute('class', 'uiWebviewHighlight')
  // el.style.backgroundColor = 'white'
  // el.style.color = 'white'
  // console.log(txt)
  clearAnnotations(el)
  var originalText = el.innerHTML.replace(/<\/p>/g, '').replace(/<p>/g, '')
  var txt = originalText
  var params = { language: 'pt-AO', text: originalText }
  LanguageTool.check(params, function (err, res) {
    if (err) {
      console.log(err)
    } else {
      // console.log(res)
      var spanOpen1 = '<u style="background-color: var(--error-bg-color);" title="'
      var spanOpen2 = '">'
      var spanClose = '</u>'
      var spanLength = spanOpen1.length + spanOpen2.length + spanClose.length
      var insertedLength = 0
      for (var i = 0; i < res.matches.length; i++) {
        var match = res.matches[i]
        console.log(match)
        var end = match.offset + match.length
        if (txt[insertedLength + end - 1] === '<') {
          end = end - 1
        }
        var replacements = ' '
        match.replacements.map(item => {
          replacements = replacements + item.value + ', '
        })
        if (replacements.indexOf('>') >= 0 || replacements.indexOf('<') >= 0) {
          // ignore < or > changes
          continue
        }
        txt = txt.slice(0, insertedLength + end) + spanClose + txt.slice(insertedLength + end)
        txt = txt.slice(0, insertedLength + match.offset) + spanOpen1 + match.message + replacements + spanOpen2 + txt.slice(insertedLength + match.offset)
        insertedLength = insertedLength + spanLength + match.message.length + replacements.length
      }
      // console.log(originalText)
      // console.log(txt)
      // console.log(el)
      el.innerHTML = el.innerHTML.replace(originalText, txt).replace(/<p><\/p>/g, '')
      // console.log(el.innerHTML)
      range.deleteContents()
      range.insertNode(el)
    }
  })
}

function getSelection () { // eslint-disable-line no-unused-vars
  var text = ''
  var sel = window.getSelection()
  if (sel.rangeCount) {
    var container = document.createElement('div')
    for (var i = 0, len = sel.rangeCount; i < len; ++i) {
      container.appendChild(sel.getRangeAt(i).cloneContents())
    }
    text = container.innerHTML.toString()
  }
  if (!text) {
    text = sel.anchorNode.data.toString()
  }
  text = text.replace(/<\/p>/g, '').replace(/<p>/g, '')
  return text
}

// global save and export keyboard shortcuts
document.addEventListener('keydown', function (event) {
  if (event.code === 'KeyS' && (event.ctrlKey || event.metaKey)) {
    event.preventDefault()
    document.querySelector('#save_button').click()
    document.cookie = 'ScrollTop=' + document.documentElement.scrollTop
    console.log('Saved!')
  }
})

</script>

<style>
:root {
  --error-bg-color: #fff2be;
  --warning-bg-color: #ebffbe;
}
.corrected {
  background: white !important;
}
.ql-indent-1 {
  padding-left: 1em;
  margin-bottom: 0px;
}
.ql-editor .ql-size-small, .ql-size-small {
  font-size: .9em !important;
}
.ql-container.ql-snow {
  border-right: 0px solid white !important;
}
.ql-toolbar.ql-snow {
  border-top: 0px solid white !important;
  border-left: 0px solid white !important;
  border-right: 0px solid white !important;
}
blockquote {
  font-size: .9em;
  padding-left: 2em !important;
  border-left: 0px solid white !important;
}
p img {
  width: auto;
  max-height:14px;
}
.fixed-div {
    position: fixed;
    top: 0;
    right: 1em;
}
.desktop .ql-toolbar {
  top: 0;
  width: 100%;
  z-index: 100;
  position: fixed;
  background: white;
}
.split-desktop .ql-toolbar {
  width: 50%;
}
.ql-tooltip {
  max-width: 320px;
}
.desktop .ql-editor {
    margin-top: 80px;
    padding: 40px;
}
#full-text-edit {
  /* Set "my-sec-counter" to 0 */
  counter-reset: my-sec-counter;
}
#full-text-edit-2 {
  /* Set "my-sec-counter" to 0 */
  counter-reset: my-sec-counter-2;
}
#full-text-edit .ql-editor p:not(.ql-align-center):not(.ql-align-right):not(.ql-indent-4)::before {
  /* Increment "my-sec-counter" by 1 */
  counter-increment: my-sec-counter;
  content: counter(my-sec-counter, decimal-leading-zero) "";
}
#full-text-edit-2 .ql-editor p:not(.ql-align-center):not(.ql-align-right):not(.ql-indent-4)::before {
  /* Increment "my-sec-counter" by 1 */
  counter-increment: my-sec-counter-2;
  content: counter(my-sec-counter-2, decimal-leading-zero) "";
}
.ql-editor p:not(.ql-align-center):not(.ql-align-right):not(.ql-indent-4)::before {
  margin-left: -40px;
  margin-right: 4px;
  text-align: left;
  color: #b8b8b8;
  display: inline-block;
  width: 36px;
  font-size: 0.8em;
}
.ql-editor {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 100px;
  max-width: 600px;
  text-align: justify;
}
.ql-hr-advance {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAYCAYAAAAGXva8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5AMOEy06HjhgowAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAAO0lEQVRIx2P8////fwY6AyaGAQCjlo5aOmrpqKWjlo5aOmrpELWUBZcEIyMjVSzA1hpiIUXxaJwOCUsBpn8KLRu6cM4AAAAASUVORK5CYII=")  !important;
}
.ql-hr {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAYCAYAAAAGXva8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5AMOEy0A2DS5EQAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAAOklEQVRIx2P8////fwY6AyaGAQCjlo5aOmrpqKUj3FIWXBKMjIxUsQBbfcJCiuLROB21dNTSUUtpCgAePAotHNRaowAAAABJRU5ErkJggg==")  !important;
}
.ql-orthography {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAYCAYAAAAGXva8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5AMOEwQ3JM+D9QAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAACmklEQVRIx+2WTyhsbxjHv3NnOiZ/MhpCshAbUwaZlWzGwsIxC0WK2WDDqFlbykqzshjJzkLDgpJZa0SSmiLZKGU5iiYL0ejM+dzVnX6MwcLv3m7db72bp+fpc97nfb7vexwA+s36oT+gf9A/C724uFBDQ4MGBwdlWdb3UPlEIyMjSEISe3t7fIc+hN7f32MYBv39/bhcLoaHh78F6vqoC4lEQi8vL5qampJhGEomk7q7u1NdXd3/197u7m6qqqp4fHwkkUggieXl5ZL5R0dHDAwM0NjYiNvtpq2tjYWFBXK53Nfae35+jiRmZmYAeHp6wuPx0NnZ+W7+4eEhLpeL2tpa5ubmiMfjjI2NIYnFxcWvQaPRKJJIp9OFWCQSQRJnZ2dF+dPT0zgcDg4ODgox27YJBAIEAoHPoblcDq/XS1dX16t4Op1GEtFotKgmm81yenpaFB8fH6e+vv5z6Pb2NpJYWVl5FbdtG7/fj9frLTqnX7q8vGR3d5d4PM78/Dytra1fg5qmWfBmqbWzs/Oq5ubmht7eXiRRXl6O3+8nGAzS1NRUBHW8fdoymYyam5vV0dEh0zSLpt2yLMViMZmmqWQyKUmybVs9PT26urrS2tqaRkdH5Xa7JUkTExPa39/X7e1tacssLS0hia2trZLWCAaDOJ1OMpkMANfX10giEom8m/t2pz/eeFbr6+uqqKhQKBQq6e1wOKx8Pq+NjY1CnaTC7n5pc3NTqVSq+M7+7xecnJwgiXA4/OE19vDwQFlZGT6fDwDLsvD5fBiGweTkJLFYjFAohNPppKWlBUk8Pz+/P0jHx8dUV1e/8lopzc7O0t7eTj6fL7R4aGgIj8dDZWUlfX19pFIpVldXqampIZvNlh6kf38Ofz30J4zyTzB3FTWPAAAAAElFTkSuQmCC")  !important;
}
.ql-ortography90 {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAYCAYAAAAGXva8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5AMOEwQ3JM+D9QAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAACmklEQVRIx+2WTyhsbxjHv3NnOiZ/MhpCshAbUwaZlWzGwsIxC0WK2WDDqFlbykqzshjJzkLDgpJZa0SSmiLZKGU5iiYL0ejM+dzVnX6MwcLv3m7db72bp+fpc97nfb7vexwA+s36oT+gf9A/C724uFBDQ4MGBwdlWdb3UPlEIyMjSEISe3t7fIc+hN7f32MYBv39/bhcLoaHh78F6vqoC4lEQi8vL5qampJhGEomk7q7u1NdXd3/197u7m6qqqp4fHwkkUggieXl5ZL5R0dHDAwM0NjYiNvtpq2tjYWFBXK53Nfae35+jiRmZmYAeHp6wuPx0NnZ+W7+4eEhLpeL2tpa5ubmiMfjjI2NIYnFxcWvQaPRKJJIp9OFWCQSQRJnZ2dF+dPT0zgcDg4ODgox27YJBAIEAoHPoblcDq/XS1dX16t4Op1GEtFotKgmm81yenpaFB8fH6e+vv5z6Pb2NpJYWVl5FbdtG7/fj9frLTqnX7q8vGR3d5d4PM78/Dytra1fg5qmWfBmqbWzs/Oq5ubmht7eXiRRXl6O3+8nGAzS1NRUBHW8fdoymYyam5vV0dEh0zSLpt2yLMViMZmmqWQyKUmybVs9PT26urrS2tqaRkdH5Xa7JUkTExPa39/X7e1tacssLS0hia2trZLWCAaDOJ1OMpkMANfX10giEom8m/t2pz/eeFbr6+uqqKhQKBQq6e1wOKx8Pq+NjY1CnaTC7n5pc3NTqVSq+M7+7xecnJwgiXA4/OE19vDwQFlZGT6fDwDLsvD5fBiGweTkJLFYjFAohNPppKWlBUk8Pz+/P0jHx8dUV1e/8lopzc7O0t7eTj6fL7R4aGgIj8dDZWUlfX19pFIpVldXqampIZvNlh6kf38Ofz30J4zyTzB3FTWPAAAAAElFTkSuQmCC")  !important;
}
.ql-image2 {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAeGVYSWZNTQAqAAAACAAFARIAAwAAAAEAAQAAARoABQAAAAEAAABKARsABQAAAAEAAABSASgAAwAAAAEAAgAAh2kABAAAAAEAAABaAAAAAAAAAEgAAAABAAAASAAAAAEAAqACAAQAAAABAAAAHKADAAQAAAABAAAAHAAAAADYTxETAAAACXBIWXMAAAsTAAALEwEAmpwYAAACZmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyIKICAgICAgICAgICAgeG1sbnM6ZXhpZj0iaHR0cDovL25zLmFkb2JlLmNvbS9leGlmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICAgICA8dGlmZjpSZXNvbHV0aW9uVW5pdD4yPC90aWZmOlJlc29sdXRpb25Vbml0PgogICAgICAgICA8ZXhpZjpDb2xvclNwYWNlPjE8L2V4aWY6Q29sb3JTcGFjZT4KICAgICAgICAgPGV4aWY6UGl4ZWxYRGltZW5zaW9uPjQ4PC9leGlmOlBpeGVsWERpbWVuc2lvbj4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjQ4PC9leGlmOlBpeGVsWURpbWVuc2lvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CrVrzg0AAAHxSURBVEgN7ZO/S5VRGIBvWigYSeJggWFt7UotLtEg4hrugeDfoHNbDU31JzTn7uCo0OYk5E0CF1FBK6Ofz8M9Lxy/e757/ZzvC899z3l/nvd857ZaAxncQMMbuNEnXn+/mGqJfxiksTRtlDeoza11pOxH6HvwN6+W1uY6iVqMGYJD+AxFKTWMQjNkbMIp/ASLlcT4C7gFozAOz6ANUYtlR27GItMRdB/bOSzAGRibfxvjfoMH8RacbAS20r6NjlosO1J3ar1/4FviB9qmHuB70q61r8EevAWv1Rx1UXo19HTDCZNdKxaLvEnWKxqRl/AYfkH4WV6WWkcWFg/DiadgHfxW2o/gFTjVa9gFfbUT4uuSOMRTPNtwJ4vYYG2jD5nNm7id9mPoHXiS9lErbXuMniIsHklvWC+B33AZ3sML8LE8ByWm8xBXlmjgKT+lrFW0zX2Vaq9XHWifB8Wca03o38BvtAjvQInDqG0qPhIf1EeYgxMo/d0wlyWKzuL+Al5ZTOdjKGFTYw5gH2ysRK3Ojt9eJ7HwgxRpsfhbJNMlZR1jppPVyYtSamiicgxf4S7YPCQeRMSFXe1E5onSFRPJHXf370NME+CJq7F5MX3uvQWb7UNjqTZoUqA2t9aRquvvF1M9iJPm01f9g/3gBprdwH/rsW38+oYplwAAAABJRU5ErkJggg==")  !important;
}
/* editor text formatting */
#editorcontainer, #admin {
  background: #FFFEEE;
  background: white;
}
.full-text-edit-style .ql-container {
  font-size: 110%;
  font-family: Georgia, Cambria, "Times New Roman", Times, serif;
}
.full-img {
  width: 100% !important;
  max-height: 100% !important;
}
.full-text-edit-style p {
  margin-bottom: 14px !important;
  text-align: justify;
}
.full-text-edit-style p.grammarError {
  background-color: #fee481;
  cursor: pointer;
}
.full-text-edit-style p[class*="ql-indent-"] {
  margin-bottom: 5px;
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 2em;
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 4em;
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 6em;
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 8em;
}
.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 12em;
}
.full-text-edit-style .ql-align-center {
  text-align: center !important;
}
.full-text-edit-style .ql-align-right {
  text-align: right !important;
}
.ql-snow .ql-editor pre.ql-syntax {
  background-color: #FFF !important;
  font-family: Georgia, Cambria, "Times New Roman", Times, serif !important;
  font-size: 120% !important;
  color: #4a4a4a !important;
}
.full-text-edit-style h2 {
  border-top: 1px #ccc dotted;
  text-align: center !important;
  padding-top: 100px !important;
  padding-bottom: 30px !important;
  margin-bottom: 30px !important;
}
.full-text-edit-style h3 {
  border-top: 1px #ccc dotted;
  padding-top: 40px;
  margin-top: 40px;
  padding-bottom: 20px;
}
.full-text-edit-style h4 {
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 1.1em;
}
.full-text-edit-style h4.ql-align-right {
  padding-top: 0px;
}
.full-text-edit-style .hr {
  margin-top: 30px;
}
.full-text-edit-style .hr-advance {
  margin-bottom: 120px;
}
.full-text-edit-style u {
    border-bottom: 2px dotted red;
    text-decoration: none;
}
.loading-overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  color: #000000;
  background-color: #FFF;
  overflow-x: hidden;
  transition: 0.5s;
  text-align: center;
  padding-top: 100px;
}
.center {
  width: 100%;
  padding: 10px;
}
.loader {
  margin: auto;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/* prevent iphone context menu */
body { -webkit-touch-callout: none !important; }
a { -webkit-user-select: none !important; }

/* Drop Down styling */

orthog-blot a {
  color: #4a4a4a !important;
  text-decoration: none !important;
}

orthog-blot a:hover, .dropdown:hover .dropbtn {
  background-color: orange;
}

orthog-blot.dropdown {
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  margin-top: 20px;
}

.dropdown-content a {
  color: black;
  padding: 2px 6px;
  text-decoration: none;
  display: block;
  text-align: left;
}

.dropdown:hover .dropdown-content {
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/content/BookTextEdit.vue